import DefaultLayout from '@/layouts/DefaultLayout.vue'

const Page = () => import('@/pages/Page.vue')

export default {
    path: '/page',
    component: DefaultLayout,
    children: [
        {
            path: ':alias',
            name: 'Page',
            component: Page
        }
    ]
}